<div class="row">
  <div class="col-12">
    <div class="alert alert-info">
      <div class="mb-3">
        <h2>Request to make payment confirmation!</h2>
      </div>
      <div>
        <p>
          Your request to make payment has been submitted successfully. Your payment reference number is: <strong>{{paymentReferenceNumber}}</strong>
        </p>
        <p>
          You will receive an email confirmation shortly with a PDF attachment of your payment application.
        </p>
      </div>
     
    </div>
   
  </div>
</div>